import { render, staticRenderFns } from "./ConfirmarNuevo.vue?vue&type=template&id=5b9339dc&scoped=true"
import script from "./ConfirmarNuevo.vue?vue&type=script&lang=js"
export * from "./ConfirmarNuevo.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarNuevo.vue?vue&type=style&index=0&id=5b9339dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9339dc",
  null
  
)

export default component.exports